// userReducer.js — savings & comments from `/users/me/*` (likes → couponLike slice)
import * as userTypes from "../types/userTypes";
import * as authTypes from "../types/authTypes";

const initialState = {
  savings: [],
  myComments: [],
  loading: false,
  error: null,
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case userTypes.USER_PORTFOLIO_REQUEST:
      return { ...state, loading: true, error: null };

    case userTypes.USER_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        savings: action.payload.savings || [],
        myComments: action.payload.myComments || [],
      };

    case userTypes.USER_PORTFOLIO_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case userTypes.USER_CLEAR:
    case authTypes.LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
}
